import React, { useEffect, useState } from 'react';

export const RecaptchaVerifierComponent = ({
  onRender,
  onError
}: {
  onRender?: (recaptchaVerifier) => void;
  onError?: (e: Error) => void;
}) => {
  const [recaptchaVerifier, setRecaptchaVerifier] = useState();
  useEffect(() => {
    window.FIREBASE.createRecaptchaVerifier({
      containerId: 'recaptcha-verifier',
      options: {
        size: 'invisible',
        callback: () => console.log('recaptcha verified')
      }
    })
      .then(setRecaptchaVerifier)
      .catch(onError);
    return () => recaptchaVerifier && recaptchaVerifier.clear();
  }, []);

  useEffect(() => {
    recaptchaVerifier && onRender && onRender(recaptchaVerifier);
  }, [recaptchaVerifier]);

  return <span id="recaptcha-verifier"></span>;
};
